export enum ReportType {
  ShopgoodwillListings = 'shopgoodwill_listings',
  EbaylListings = 'ebay_listings',
  OfferUpListings = 'offer_up_listings',
  ShopifyListings = 'shopify_listings',
  GoodwillfindsListings = 'goodwillfinds_listings',
  EtsyListings = 'etsy_listings',
  AmazonListing = 'amazon_listings',
  DepopListings = 'depop_listings',
  PaidOrders = 'paid_orders',
  Orders = 'orders',
  OrderItems = 'order_items',
  OrderItemsByLocation = 'order_items_by_location',
  Refunds = 'refunds',
  ManifestItems = 'manifest_items',
  Shipments = 'shipments',
  Products = 'products',
  EventLogs = 'event_logs',
  LocalProducts = 'local_products',
  EmbeddedListings = 'embedded_listings'
}

export interface TimeFrameDimensionOptionType {
  label: string
  value: string
  description?: string
}
